/*
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2025, Zumper
 */

import { cardBack } from '@zcode/nr/es/shared/api'
import type { CardBackResponse, Listable, Pin, RawPinInventorySearch } from '@zcode/state-type'
import type { Dispatch, SetStateAction } from 'react'

export const fetchCardBackData = async (
  entity: Listable | Pin<RawPinInventorySearch>,
  setCardBackData: Dispatch<SetStateAction<CardBackResponse>>,
  cardBackDataHasLoaded: Dispatch<SetStateAction<boolean>>
) => {
  const cardBackQuery: { [key: string]: { pl_id?: number; pb_id?: number } } = {}
  const { groupId, pbId, plId } = entity

  if (pbId) {
    cardBackQuery[`${groupId}`] = { pb_id: pbId }
  } else if (plId) {
    cardBackQuery[`${groupId}`] = { pl_id: plId }
  } else {
    cardBackQuery[`${groupId}`] = {}
  }

  const cardBackData = await cardBack.query(cardBackQuery)
  setCardBackData(cardBackData)
  cardBackDataHasLoaded(true)
}
